import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

function ItemMaster() {
  const [formData, setFormData] = useState({
    id: "",
    store_division: "",
    store_unit: "",
    store_batch_no: "",
    store_item_name: "",
    store_department: "",
    store_min_qty: "",
    store_hsn: "",
    store_igst: ""
  });
  const [isAdmin , setIsAdmin] = useState('')

  const [showHsnDropdown, setShowHsnDropdown] = useState(false);
  const [showDeptDropdown, setShowDeptDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");


  const [ldata, setLdata] = useState(null);
  const [items, setItems] = useState([]);

  // dropdown data
//   const [divisions, setDivisions] = useState([]);
  const [units, setUnits] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [hsnList, setHsnList] = useState([]);

  const [alert, setAlert] = useState({ show: false, msg: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Save / Update
  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("id", formData.id);
    fd.append("store_division", formData.store_division);
    fd.append("store_unit", formData.store_unit);
    fd.append("store_batch_no", formData.store_batch_no);
    fd.append("store_item_name", formData.store_item_name);
    fd.append("store_department", formData.store_department);
    fd.append("store_min_qty", formData.store_min_qty);
    fd.append("store_hsn", formData.store_hsn);
    fd.append("store_igst", formData.store_igst);
    fd.append("user_id", ldata?.user_id);

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.itemSaveUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status) {
        setAlert({ show: true, msg: response.data.success, type: "success" });
        setFormData({
          id: "",
          store_division: "",
          store_unit: "",
          store_batch_no: "",
          store_item_name: "",
          store_department: "",
          store_min_qty: "",
          store_hsn: "",
          store_igst: "",
        });
        getItems();
        toast.success("item created successfully")
      } else {
        toast.error( response.data.success);
      }
    } catch (error) {
      toast.error(error)
    }
  };

  // Fetch all items
  const getItems = async () => {
    const fd = new FormData();
    fd.append("user_id", ldata?.user_id);
    try {
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.itemListUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log(JSON.stringify(res))
     if (res.data.status) {
  setItems(res.data.data || []);
} else {
  setItems([]);  // fallback
}

    } catch (error) {
      console.error(error);
    }
  };

  // Delete item
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    const fd = new FormData();
    fd.append("id", id);
    try {
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.itemDeleteUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data.status) {
        getItems();
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Edit item
  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      store_division: item.store_division,
      store_unit: item.store_unit,
      store_batch_no: item.store_batch_no,
      store_item_name: item.store_item_name,
      store_department: item.store_department,
      store_min_qty: item.store_min_qty,
      store_hsn: item.store_hsn,
      store_igst: item.store_igst,
    });
  };

  // Fetch dropdown data (division, unit, department, hsn)
  const getDropdownData = async () => {
    try {
    //   let divRes = await axios.get(AppConst.BASE_URL + AppConst.divisionListUrl);
    //   if (divRes.data.status) setDivisions(divRes.data.data);
let unitRes = await axios.get(AppConst.BASE_URL + AppConst.GetAllStoreUnits);

if (unitRes.data.status) {
  setUnits(unitRes.data.list || []);   // ✅ list use karo
}

let depRes = await axios.get(AppConst.BASE_URL + AppConst.GetAllStoreDepartments);

if (depRes.data.status) {
  setDepartments(depRes.data.list || []);   // ✅ list use karo
}


let hsnRes = await axios.get(AppConst.BASE_URL + AppConst.GetAllStoreHns);
console.log("Hsn :", hsnRes.data);
if (hsnRes.data.status) {
  setHsnList(hsnRes.data.list || []);   // ✅ list use karo
}


    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
      const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      getDropdownData();
      getItems();
    }
  }, []);

  return (
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xxl-12">
            <div class="card">
              <div class="card-body">
                <h5>Item Master</h5>
                <form onSubmit={handleSubmit}>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-label">Division</label>
                      <select
                        class="form-control"
                        name="store_division"
                        onChange={handleChange}
                        value={formData.store_division}
                      >
                        <option value="">Select Division</option>
                        
                          <option name="div1">
                          Div 1
                          </option>
                            <option name="div2">
                          Div 2
                          </option>
                      
                        <option name="div3">
                          Div 3
                          </option>
                      
                      
                      </select>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label">Unit</label>
                      <select
                        class="form-control"
                        name="store_unit"
                        onChange={handleChange}
                        value={formData.store_unit}
                      >
                        <option value="">Select Unit</option>
                       {units.map((u) => (
  <option key={u.id} value={u.store_settings_unit_name}>
    {u.store_settings_unit_name}
  </option>
))}

                      </select>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label">Batch No</label>
                      <input
                        type="text"
                        class="form-control"
                        name="store_batch_no"
                        value={formData.store_batch_no}
                        onChange={handleChange}
                      />
                    </div>

                    <div class="col-md-4">
                      <label class="form-label">Item Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="store_item_name"
                        value={formData.store_item_name}
                        onChange={handleChange}
                      />
                    </div>

                   <div className="col-md-4 position-relative">
  <label className="form-label">Department</label>
  <input
    type="text"
    className="form-control"
    placeholder="Search Department"
    value={formData.store_department}
    onChange={(e) => {
      const value = e.target.value;
      setFormData((prev) => ({
        ...prev,
        store_department: value,
      }));
    }}
    onKeyDown={(e) => {
      // ek hi backspace me clear ho jaye
      if (e.key === "Backspace" && formData.store_department) {
        e.preventDefault();
        setFormData((prev) => ({
          ...prev,
          store_department: "",
        }));
      }
    }}
    onFocus={() => setShowDeptDropdown(true)}
    onBlur={() => setTimeout(() => setShowDeptDropdown(false), 200)}
  />

  {showDeptDropdown && (
    <ul
      className="list-group position-absolute w-100"
      style={{ maxHeight: "150px", overflowY: "auto", zIndex: 1000 }}
    >
      {departments
        .filter((dep) =>
          dep.store_settings_department
            .toLowerCase()
            .includes(formData.store_department.toLowerCase())
        )
        .map((dep, index) => (
          <li
            key={index}
            className="list-group-item list-group-item-action"
            onMouseDown={() => {
              setFormData((prev) => ({
                ...prev,
                store_department: dep.store_settings_department,
              }));
              setShowDeptDropdown(false);
            }}
            style={{ cursor: "pointer" }}
          >
            {dep.store_settings_department}
          </li>
        ))}

      {departments.filter((dep) =>
        dep.store_settings_department
          .toLowerCase()
          .includes(formData.store_department.toLowerCase())
      ).length === 0 && (
        <li className="list-group-item text-muted">No Department found</li>
      )}
    </ul>
  )}
</div>


                    <div class="col-md-4">
                      <label class="form-label">Min Qty</label>
                      <input
                        type="number"
                        class="form-control"
                        name="store_min_qty"
                        value={formData.store_min_qty}
                        onChange={handleChange}
                      />
                    </div>
<div className="col-md-4 position-relative">
  <label className="form-label">HSN</label>
  <input
    type="text"
    className="form-control"
    placeholder="Search HSN"
    value={formData.store_hsn}
    onChange={(e) => {
      const value = e.target.value;
      setFormData((prev) => ({
        ...prev,
        store_hsn: value,
      }));
    }}
    onKeyDown={(e) => {
      // ek hi backspace me clear
      if (e.key === "Backspace" && formData.store_hsn) {
        e.preventDefault();
        setFormData((prev) => ({
          ...prev,
          store_hsn: "",
          store_igst: "",
        }));
      }
    }}
    onFocus={() => setShowHsnDropdown(true)}
    onBlur={() => setTimeout(() => setShowHsnDropdown(false), 200)} // delay for click
  />

  {showHsnDropdown && (
    <ul
      className="list-group position-absolute w-100"
      style={{ maxHeight: "150px", overflowY: "auto", zIndex: 1000 }}
    >
      {hsnList
        .filter((h) =>
          h.store_hsn.toLowerCase().includes(formData.store_hsn.toLowerCase())
        )
        .map((h, index) => (
          <li
            key={index}
            className="list-group-item list-group-item-action"
            onMouseDown={() => {
              setFormData((prev) => ({
                ...prev,
                store_hsn: h.store_hsn,
                store_igst: h.store_igst, // igst bhi set hoga
              }));
              setShowHsnDropdown(false);
            }}
            style={{ cursor: "pointer" }}
          >
            {h.store_hsn}{" "}
            <span className="text-muted" style={{ fontSize: "12px" }}>
              (IGST: {h.store_igst})
            </span>
          </li>
        ))}

      {hsnList.filter((h) =>
        h.store_hsn.toLowerCase().includes(formData.store_hsn.toLowerCase())
      ).length === 0 && (
        <li className="list-group-item text-muted">No HSN found</li>
      )}
    </ul>
  )}

  {/* Hidden IGST input */}
  <input type="hidden" name="store_igst" value={formData.store_igst || ""} />
</div>



                    <div class="col-12 mt-3 text-end">
                      <button type="submit" class="btn btn-primary">
                        {formData.id ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </form>

             

                <hr />
                <div className="flex justify-content-between p-2" style={{display: "flex", alignItems: "center"}}>
             <h6>Item List</h6>
<div className="mb-2 mt-2 col-4">
  <input
    type="text"
    className="form-control"
    placeholder="Search by Item, HSN, Department, Batch"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

                </div>

{/* 🔍 Search Input */}

<table className="table table-bordered">
  <thead>
    <tr>
      <th>#</th>
      <th>Division</th>
      <th>Unit</th>
      <th>Batch</th>
      <th>Item</th>
      <th>Department</th>
      <th>Min Qty</th>
      <th>HSN</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {items
      .filter((it) => {
        if (!searchTerm) return true; // agar search empty h to sab show
        const term = searchTerm.toLowerCase();
        return (
          it.store_item_name?.toLowerCase().includes(term) ||
          it.store_hsn?.toLowerCase().includes(term) ||
          it.store_department?.toLowerCase().includes(term) ||
          it.store_batch_no?.toLowerCase().includes(term)
        );
      })
      .map((it, i) => (
        <tr key={it.id}>
          <td>{i + 1}</td>
          <td>{it.store_division}</td>
          <td>{it.store_unit}</td>
          <td>{it.store_batch_no}</td>
          <td>{it.store_item_name}</td>
          <td>{it.store_department}</td>
          <td>{it.store_min_qty}</td>
          <td>{it.store_hsn}</td>
          <td>
            <button
              className="btn btn-sm btn-warning me-2"
              onClick={() => handleEdit(it)}
                   disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            >
              Edit
            </button>
            <button
              className="btn btn-sm btn-danger"
                   disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
              onClick={() => handleDelete(it.id)}
            >
              Delete
            </button>
          </td>
        </tr>
      ))}
  </tbody>
</table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ItemMaster;
